import ColorLegend from './color-legend'
import shouldRenderLegend, { BESIDE_CHART } from './should-render-legend'

/**
 * Checks whether the color legend should render based on the settings of the
 * chart designer. If it should render, renders the legend in the given
 * container.
 *
 * This function is only for legends outside the chart body and not
 * legends alongside the title of the chart.
 *
 * @param container the container that the legend should be rendered in
 *
 * @param model {ChartDesigner} the current ChartDesigner model
 */
function renderColorLegend(container, model) {
	if (!shouldRenderLegend(model, BESIDE_CHART)) return null

	const legendType = model.get('legends')[0].legendType
	const colorLegend = new ColorLegend({
		chart: model,
		labels: true,
		legendType
	})
	container.append(colorLegend.el)
	colorLegend.render()

	return colorLegend
}

export default renderColorLegend
renderColorLegend.__filename__ = 'charts/render-chart-color-legend.js'
